import type { ReactNode } from 'react'
import { cn } from './util.ts'

export interface KbdProps {
  /** One key per entry: ['⌘', 'K'] or ['g', 't']. */
  keys?: string[]
  children?: ReactNode
  tone?: 'default' | 'onAccent' | 'plain'
  className?: string
}

const tones = {
  default: 'bg-sunken text-ink-muted ring-1 ring-line-strong ring-inset shadow-raised',
  onAccent: 'bg-accent-ink/10 text-accent-ink ring-1 ring-accent-ink/20 ring-inset',
  plain: 'text-ink-faint ring-1 ring-line ring-inset',
}

/** A key hint: <Kbd keys={['⌘', 'K']} />. */
export function Kbd({ keys, children, tone = 'default', className }: KbdProps) {
  const list = keys ?? [children]
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      {list.map((k, i) => (
        <kbd
          key={i}
          className={cn(
            'inline-flex h-5 min-w-5 items-center justify-center rounded-xs px-1 text-xs leading-none font-medium uppercase',
            tones[tone],
          )}
        >
          {k}
        </kbd>
      ))}
    </span>
  )
}
